// extracted by mini-css-extract-plugin
module.exports = {"tablepd":"index_tablepd_GJMqw","locked":"index_locked_WW5gH"};